<template>
<div class="login-section">
  <div class="login-box">
    <h3>数智大屏登录</h3>
    <p :style="tit?'':'display:none'">{{titexplain}}</p>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="ruleForm.phone" name="phone" placeholder="请输入手机号"/>
      </el-form-item>
      <el-form-item label="验证码" prop="vcode">
        <el-input v-model="ruleForm.vcode" placeholder="请输入验证码">
          <el-button slot="append" class="codebtn" :disabled="disabled1" :loading="btnText1Load" @click="bindforgetSendCode('ruleForm', 'btnText', 'disabled1', 'btnText1Load')">
            {{ btnText }}
          </el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-button class="submit-btn" style="margin-top: 32px" :loading="gologin" @click="onSubmit" >{{submitname}}</el-button>
  </div>
</div>
</template>

<script>
import myStorage from '../../../bll/utils'
import EventBus from '../../../bll/eventbus'
export default {
  name: 'login',
  data () {
    const phones = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('手机号格式不正确'))
        }
      }
    }
    return {
      tit: true,
      ruleForm: {
        phone: '',
        vcode: ''
      },
      titexplain: '',
      submitname: '登 录',
      btnTextLoad: false,
      disabled1: false,
      btnText1Load: false,
      gologin: false,
      btnText: '获取验证码',
      rules: {
        phone: [
          { required: true, validator: phones, trigger: 'blur' }
        ],
        vcode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    bindforgetSendCode (names, tys, dis, load) {
      this.$refs[names].validateField('phone', async (errorMessage) => {
        if (!errorMessage) {
          this[load] = true
          const url = '/sle/login/sms';
          this.$api.post(url, { phone: this[names].phone }, (res) => {
            console.log('res:', res)
            if (res.data.code === '000000') {
              this.$message({
                message: '验证码已发送',
                type: 'success'
              })
              this[load] = false
              this[dis] = true
              this[tys] = '发送中...'
              setTimeout(() => {
                this.doLoop(120, tys, dis)
              }, 500)
            } else {
              console.log('sss')
              this[load] = false
              if (!res.data.code) {
                this.$message({
                  message: res.data.message || '获取失败，请稍后再试！',
                  type: 'error'
                })
              }
            }
          }, 'json')
        } else {
          return false
        }
      })
    },
    doLoop: function (seconds, tys, dis) {
      seconds = seconds || 120
      this[tys] = seconds + 's后获取'
      const countdown = setInterval(() => {
        if (seconds > 0) {
          this[tys] = seconds + 's后获取'
          --seconds
        } else {
          this[tys] = '获取验证码'
          this[dis] = false
          clearInterval(countdown)
        }
      }, 1000)
    },
    onSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.gologin = true
          // this.gologin(this.ruleForm)

          const url = '/sle/login/login'
          this.$api.post(url, { mobile: this.ruleForm.phone, smsCode: this.ruleForm.vcode }, (res) => {
            console.log('res:', res)
            if (res.data.code === '000000') {
              this.$message({
                message: '登录成功！',
                type: 'success'
              })
              let token = res.data.data.token || ''
              if (token) {
                myStorage.setItem('localStorage', 'token', token)
                this.$emit('getData', token)
                EventBus.$emit('getStartPlayback')
              }
            } else {
              console.log('sss')
              if (!res.data.code) {
                this.$message({
                  message: res.data.message || '登录失败，请稍后再试！',
                  type: 'error'
                })
              }
            }
            this.gologin = false
          }, 'json')
        }
      })
    }
  }
}
</script>

<style scoped>
.login-section{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-box{
  width: 360px;
  height: 350px;
  padding: 20px;
  background: rgba(255,255,255,.85);
  border-radius: 12px;
  box-shadow: 3px 16px 13px rgba(0,0,0,.54);
  position: relative;
  border: 1px solid #fff;
}
.login-box>h3{
  text-align: center;
  font-family: 微软雅黑;
  font-size: 24px;
  font-weight: normal;
}
.login-box>p{
  text-align: center;
  height: 24px;
  line-height: 24px;
  margin: 3px auto;
  font-size: 16px;
  color: red;
}

</style>
<style>
.login-box .el-input__inner{
  height: 50px !important;
  line-height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ale/modules/login.vue